/*
|--------------------------------------------------------------------------
| Is In Viewport
| 
| This function can be used to detect whether or not and element is in view.
|--------------------------------------------------------------------------
*/

const isInView = (element) => {
  const rect = element.getBoundingClientRect()
  var elTop = rect.top
  var elBottom = rect.bottom

  // (Partially visible elements return true)
  return elTop < window.innerHeight && elBottom >= 0
}

export default isInView
